<section id="content" class="doc-mgmt-view" *ngIf="records">
  <div class="page page-profile">

    <!-- page header -->
    <div class="pageheader">
      <h2>{{ lang.documentView }}</h2>
      <div class="page-bar">
        <ul class="page-breadcrumb">
          <li>
            <a [routerLink]="'/'+AppFrontRoutes.DASHBOARD"><i class="fa fa-home"></i>
              {{AppSettings.SITE_TITLE | titlecase}}</a>
          </li>
          
          <li>
            <a [routerLink]="'/'+AppFrontRoutes.DOCUMENTMANG_VIEW+'/'+id">{{ lang.documentView }}</a>
          </li>

          <li>
            <a>{{ single_data?.doc_code }}</a>
          </li>

          <li>
            <a>{{ single_data?.document_title }}</a>
          </li>

        </ul>
        <div style="float: right;">
          <div class="social-icons">
            <a class="plus-vdead" (click)="viewdead()">
              <i class="fa fa-list"></i>
            </a>


            <a class="plus-edit" (click)="editDocumentmang(this.id)" [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'" >
              <i class="fa fa-edit"></i>
            </a>

          </div>
        </div>

      </div>
    </div>

    <!-- page content -->
    <div class="pagecontent">

      <!-- row -->
      <div class="row">
        <div class="col-md-12">
          <div class="tile tile-simple">

            <!-- tile body -->
            <div class="tile-body" [ngSwitch]="pageView">
              <div role="tabpanel" *ngSwitchCase="'list'">

                <div class="row p-10">
                  <div class="col-sm-1">                  

                    <div class="social-icons">

                      <a class="plus-add" (click)="newaction(this.id)"  [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'" >
                        <i class="fa fa-plus"></i>
                      </a>

                      <a class="plus-export" data-toggle="modal" data-target="#datatableExport1"
                          data-options="splash-2 splash-ef-4">
                        <span class="glyphicon glyphicon-export"></span>
                      </a>
                      
                      <a class="plus-delete" *ngIf="deleteOption" (click)="multiDelete(this.id)" [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'" >
                        <span class="glyphicon glyphicon-trash"></span>
                      </a>

                    </div>
                  </div>                  
                  
                  <div class="col-sm-6">

                    <a class="plus-add" (click)="add(this.id)">
                      <button class="btn btn-success">{{ lang.generalData }}</button>
                    </a>

                  <a class="plus-add" (click)="occurrence_details(this.id)">
                    <button class="btn btn-success">{{ lang.repetitionData }}</button>
                  </a>
                  </div>

                  <div  class="col-sm-5">
                    <input
                    style="float: right;width: 40%;"
                    #search
                    id="search"
                    type="text"
                    class="form-control"
                    placeholder="Search"
                    aria-label="Search"
                    aria-describedby="basic-addon1"
                  />                        
                  </div>                    

                </div>

                

                <div class="table-responsive" style="overflow: auto;">
      
                  <table datatable [dtOptions]="datatableOptions1" class="table-striped table-sm row-border hover" id="table1">
                    
                    <thead>
                      <tr>
                        <th>Hidden.No</th>
                        <th>
                          <label class="checkbox checkbox-custom-alt checkbox-custom-sm">
                            <input type="checkbox"><i></i>
                          </label>
                        </th>
                        <th>S.No</th>
                        <th>{{ lang.revision }}</th>
                        <th>{{ lang.revisionDate }}</th>
                        <th>{{ lang.descriptionofChanges }}</th>
                        <th>{{ lang.attachments }}</th>
                        <th>{{ lang.writtenBy }}</th>
                        <th>{{ lang.verifiedBy }}</th>
                        <th>{{ lang.approvedBy }}</th>
                        <th>{{ lang.distributionStatus }}</th>
                        <th>{{ lang.sendTo }}</th>
                        <th>{{ lang.dateofSent }}</th>
                        <th>{{ lang.action }}</th>
                      </tr>
                    </thead>

                    <tbody>
                      <tr *ngFor="let record of records let i = index" id="{{record.intervention_id}}" [style.color]="record.color">
                        <td>{{i+1}}</td>
                        <td></td>
                        <td>{{i+1}}</td>
                        <td>{{record.revision_code }}</td>
                        <td>{{record.rev_date }}</td>
                        <td>{{record.revision_discrp }}</td>
                        <td>
                          <div *ngFor='let attach of record.revision_attach.split(",")'>
                            <a href="http://vmi313621.contaboserver.net/Software_backend/uploads/documents_managment/{{attach}}" target="_blank">{{attach}}</a>
                          </div>
                          </td>
                        <td>{{record.rev_written_by }}</td>
                        <td>{{record.rev_verified_by }}</td>
                        <td>{{record.rev_approved_by }}</td>
                        <td>
                          <div [innerHTML]="record.dist_status" style="color: red;"></div></td>
                        <td>{{record.dist_send }}</td>
                        <td>{{record.dist_date }}</td>
                        <td>
                          <div class="btn-group dropup">
                            
                            <button type="button" class="btn btn-info dropdown-toggle circle_btn" data-toggle="dropdown"
                              aria-expanded="false"><i class="fa fa-tasks"></i></button>

                            <ul class="dropdown-menu dropdown-menu-right action_btn" role="menu">
                              <li><a class="edit_action" (click)="edit(record.intervention_id,record.doc_id)" [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'" ><i class="fa fa-edit"></i> {{ lang.modify }}</a></li>
                              <li><a class="edit_action" (click)="duplicate(record.intervention_id,record.doc_id)" [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'" ><i class="fa fa-files-o fa-fw text-red"></i> {{ lang.duplicate }}</a></li>
                              <li><a class="delete_action" (click)="delete(record.intervention_id,record.doc_id)" [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'" ><i class="fa fa-trash"></i> {{ lang.erase }}</a></li>
                              <li><a class="edit_action" (click)="edit(record.timetable_actionId,record.timetable_Id)" [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'" ><i class="fa fa-envelope"></i> {{ lang.mail }}</a></li>
                       
                            </ul>
                          </div>
                        </td>
                      </tr>
                    </tbody>

                  </table>
                </div>
              </div>

            
            </div>

          </div>
        </div>
      </div>

    </div>
  </div>
</section>


<div class="modal splash fade" id="datatableExport1" tabindex="-1" role="dialog" aria-hidden="true">

  <div class="modal-dialog">
    <div class="modal-content">
  
      <div class="modal-header">
        <h3 class="modal-title custom-font">{{ lang?.selectColumns }}</h3>
      </div>

      <div class="modal-body column_export">
        <div class="row select-alls">
          <label class="checkbox checkbox-custom-alt checkbox-custom-sm"> <input type="checkbox"
              (change)="export1_select_deselect_all($event)"><i></i> {{ lang?.selectAll }} </label>
        </div>
        <div class="row flexs">

          <div class="active-left">
            <h2>{{ lang?.activeColumns }}</h2>

            <div class="row" *ngFor="let option of datatableCols1">
              <label class="checkbox checkbox-custom-alt checkbox-custom-sm">
                <input type="checkbox" value="{{option.id}}" [checked]="option.isSelected" class="col_select1"
                  (change)="export1_select_deselect($event)"><i></i> {{option.value}}
              </label>
            </div>

          </div>
<!-- 
          <div class="active-left">
            <h2>Additional Columns</h2>

            <div class="row" *ngFor="let option of datatableAddCols1">
              <label class="checkbox checkbox-custom-alt checkbox-custom-sm">
                <input type="checkbox" value="{{option.id}}" [checked]="option.isSelected" class="col_select1"
                  (change)="export1_select_deselect($event)"><i></i> {{option.value}}
              </label>
            </div>

          </div> -->

        </div>

      </div>

      <div class="modal-footer">
        <div id="datatableExportBtn1" class="export_dynamic_btn">
        </div>
        <button class="btn btn-warning" data-dismiss="modal">{{ lang?.close }}</button>
      </div>

    </div>
  </div>
</div>